var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"articleList",staticClass:"article-list-wrapper"},[_vm._l((_vm.blogs),function(blog,index){return _c('ArticleItem',{key:blog.id,attrs:{"blog":blog,"index":index}})}),_vm._v(" "),(!_vm.blogs.length)?_c('div',{staticClass:"loader"}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58f8e2aa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/ArticleList/articleList.vue
// module id = null
// module chunks = 